import React, { JSX, Ref } from 'react';

import BreadcrumbExpander from './BreadcrumbExpander.jsx';
import BreadcrumbSeparator from './BreadcrumbSeparator.jsx';

export interface CollapseI {
  itemsBefore?: number;
  itemsAfter?: number;
  max?: number;
}

interface BreadcrumbI {
  items: React.ReactNode;
  separator: React.ReactNode | string;
  collapse: CollapseI;
  ref: Ref<HTMLDivElement>;
}

export const createBreadcrumb = ({
  items,
  separator,
  collapse,
  ref,
}: BreadcrumbI) => {
  const { itemsBefore = 1, itemsAfter = 1, max = 3 } = collapse;

  let children = React.Children.toArray(items).map((child, index) => (
    <div key={`breadcrumb_item${index}`}>{child}</div>
  ));

  if (children.length > max) {
    children = [
      ...children.slice(0, itemsBefore),
      <BreadcrumbExpander
        ref={ref}
        children={children.slice(itemsBefore, children.length - itemsAfter)}
      />,
      ...children.slice(children.length - itemsAfter, children.length),
    ];
  }

  children = children.reduce((acc: JSX.Element[], child, index) => {
    if (index < children.length - 1) {
      acc.push(
        child,
        <BreadcrumbSeparator key={`breadcrumb_sep${index}`}>
          {separator}
        </BreadcrumbSeparator>,
      );
    } else {
      acc.push(child);
    }
    return acc;
  }, []);

  return children;
};
